import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  ModalFooter,
  Button,
} from 'reactstrap';

const ContentHubModal = ({
  hubCancelModal,
  completeHubCancellation,
  setHubCancelModal,
  checkedContentHub,
}) => {
  const { t } = useTranslation(['review_changes', 'buttons']);

  return (
    <Modal isOpen={hubCancelModal} centered={true}>
      <ModalHeader>{t('revchn_content_hub_label')}</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>
              {checkedContentHub?.length > 1
                ? t('revchn_cancel_all_changes')
                : t('revchn_cancel_changes')}
            </Label>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color='danger' onClick={() => completeHubCancellation()}>
          {t('buttons:btn_yes')}
        </Button>
        <Button color='success' onClick={() => setHubCancelModal(false)}>
          {t('buttons:btn_no')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ContentHubModal;
